import { render } from "./RevisionSolicitudesIngreso.vue?vue&type=template&id=2700b200&scoped=true"
import script from "./RevisionSolicitudesIngreso.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitudesIngreso.vue?vue&type=script&lang=js"

import "./RevisionSolicitudesIngreso.vue?vue&type=style&index=0&id=2700b200&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2700b200"]])

export default __exports__